export const fonts = {
  body: "Roboto,Montserrat, Helvetica, Arial, sans-serif",
  heading: "Roboto,  Montserrat, system-ui, sans-serif",
  monospace: "Menlo, monospace",
  siteTitle: "Roboto, Montserrat, system-ui, sans-serif",
  siteTitleItalics: "kinescope,cursive",
};
export const fontSizes = [12, 14, 16, 20, 24, 32, 48, 64, 96];
export const fontWeights = {
  thin: 100,
  light: 200,
  body: 300,
  button: 500,
  heavy: 500,
  heading: 700,
  bold: 600,

  100: 100,
  200: 200,
  300: 300,
  500: 500,
  700: 700,
};
export const lineHeights = {
  body: 1.5,
  heading: 1,
};
export const sharedHeadingStyles = {
  m: 0,
  color: "textHeading",
  fontFamily: "heading",
  lineHeight: "heading",
  fontWeight: "body",
  letterSpacing: 1.5,
  marginBlockStart: ".5em",
};

export const headingStyles = {
  title: {
    ...sharedHeadingStyles,
    fontWeight: "bold",
    color: "white",
    fontSize: [6, 7, 7],
    small: {
      fontSize: [4, 5, 5],
    },
  },
  h1: {
    ...sharedHeadingStyles,
    textAlign: "center",
    fontSize: 5,
  },
  h2: {
    ...sharedHeadingStyles,

    fontSize: [5, 5, 6],
  },
  h3: {
    ...sharedHeadingStyles,
    fontSize: 3,
  },
  h4: {
    ...sharedHeadingStyles,
    fontSize: 2,
  },
  h5: {
    ...sharedHeadingStyles,
    fontSize: 1,
  },
  h6: {
    ...sharedHeadingStyles,
    fontSize: 0,
  },
};

export const textStyles = {
  jobHeading: {
    color: "primary",
    fontSize: [3, 3, 5],
    fontWeight: "bold",
  },
  heading: { color: "textHeading" },
  cardHeading:{color:"white"},
  a: {
    textDecoration: "none",
    color: "primary",
    //fontSize: [3, 4],
  },
  p: {
    color: "text",
    fontFamily: "body",
    fontWeight: "light",
    lineHeight: "body",
    fontSize: 4,
    //marginBlockStart: '.5em',
    marginBlockEnd: "1.5em",
    nomargin: {
      color: "text",
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body",
      fontSize: 2,
    },
  },
  ul: {
    fontFamily: "body",
    fontWeight: "light",
    lineHeight: "body",
    fontSize: 3,
    listStyleType: "disc",
  },
};

const typography = {
  fonts: { ...fonts },
  fontSizes: { ...fontSizes },
  fontWeights: { ...fontWeights },
  lineHeights: { ...lineHeights },
};

export default typography;

/*
  body: 'Roboto, Helvetica, Arial, sans-serif',
  heading: '"FS Siena", Roboto, Montserrat, system-ui, sans-serif',
  monospace: 'Menlo, monospace',
  siteTitle: "'TSXSBG+Senlot-ExtBol',Roboto, Montserrat, system-ui, sans-serif",
  siteTitleItalics: "kinescope,cursive",
*/
